import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { relationshipModel } from '~/models';
import { Stepper } from '../Stepper';
import styles from './DesktopPane.module.scss';
export const DesktopPane = (param)=>{
    let { stepperSteps, activeStepIndex, onStepClick, completedSteps, activeSteps, testId } = param;
    const { relationship } = useCobConfig();
    const vendorLogoUrl = relationshipModel.vendorLogoUrl({
        vendor: relationship.vendor
    });
    return /*#__PURE__*/ _jsx("aside", {
        className: styles.root,
        "data-testid": testId,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.stepper,
            children: [
                vendorLogoUrl ? /*#__PURE__*/ _jsx("div", {
                    "data-testid": testId && "".concat(testId, "-logo"),
                    className: styles.logoImg,
                    style: {
                        backgroundImage: "url(".concat(vendorLogoUrl, ")")
                    }
                }) : /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    className: styles.logoTxt,
                    children: relationship.vendor.name
                }),
                /*#__PURE__*/ _jsx(Stepper, {
                    steps: stepperSteps,
                    completedSteps: completedSteps || [],
                    activeStepIndex: activeStepIndex,
                    onStepClick: onStepClick,
                    testId: testId && testId + '-stepper',
                    activeSteps: activeSteps || []
                })
            ]
        })
    });
};
